/* eslint-disable no-unused-vars */
export enum VALIDATION {
  REQUIRED = 'required',
}

export enum FORM_TYPE {
  CONTROL = 'control',
  GROUP = 'group',
  ARRAY = 'array',
}
